import { Icon, tokens, useSystemNotification } from '@gripp/shared-ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet } from 'react-native';

type InviteShareButtonProps = {
  url?: string;
};

export const InviteShareButton = ({ url }: InviteShareButtonProps) => {
  const { t } = useTranslation();
  const { showSuccess, showError } = useSystemNotification();

  const handlePress = useCallback(async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      showSuccess(t('invitation.invitePeople.copiedInvitationLink'));
    } catch {
      showError(t('invitation.invitePeople.errorCopyingInvitationLink'));
    }
  }, [url, t, showSuccess, showError]);

  return (
    <Pressable
      onPress={handlePress}
      disabled={!url}
      style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
      testID="invite-share-button"
      accessibilityRole="button"
      accessibilityLabel={t('invitation.invitePeople.copyInviteLink')}
    >
      <Icon
        name="Share"
        size={20}
        color={tokens.colors.brand.black}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    padding: tokens.spacing.xs,
    borderRadius: tokens.borderRadius.sm,
  },
  buttonPressed: {
    opacity: 0.6,
  },
});
